module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "app"
    }
  }, [_c('theme-provider'), _c('section', {
    staticClass: "flex w-full h-screen opacity-80 relative items-center justify-center",
    style: (("background-color: #303639; background-image: url(" + ('../static/hero-wallpaper.jpg') + "); background-repeat: no-repat; background-size: cover; background-blend-mode: multiply;  "))
  }, [(!_vm.isMovil) ? _c('div', {
    staticClass: "footer-copy"
  }, [_c('small', [_vm._v(" © Copyright " + _vm._s(new Date().getFullYear()) + " - Todos los derechos reservados " + _vm._s(_vm.empresaFull))])]) : _vm._e(), (!_vm.isMovil) ? _c('div', {
    staticClass: "d-flex ai-center jc-center header-logo"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/logo.png",
      "max-width": "150",
      "contain": "contain"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center h-full w-full"
  }, [_c('div', {
    staticClass: "d-flex flex-col ai-center mb-2"
  }, [_c('h1', {
    staticClass: "font-black white--text",
    class: _vm.isMovil ? 'font-size-45' : 'font-size-40'
  }, [_vm._v("Help Desk")])]), _c('v-card', {
    staticClass: "elevation-8 pa-3 card-principal",
    attrs: {
      "width": _vm.isMovil ? '100%' : 400
    }
  }, [(!_vm.hideTabs) ? _c('v-tabs', {
    attrs: {
      "color": "primary",
      "dense": "dense",
      "centered": "centered"
    }
  }, [_c('v-tab', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Iniciar Sesión")]), _c('v-tab', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Registrarse")])], 1) : _vm._e(), _c('v-tabs-items', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('router-view')], 1)], 1)], 1), _c('notifications', {
    class: _vm.isMovil ? 'width-full' : '',
    attrs: {
      "position": "top right"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('v-alert', {
          staticClass: "elevation-2 py-3 ma-1 animated fadeInRight faster",
          attrs: {
            "dense": "dense",
            "border": "left",
            "type": props.item.type
          }
        }, [_c('small', {
          staticClass: "font-size-12"
        }, [_vm._v(_vm._s(props.item.text))])])]
      }
    }])
  })], 1), (_vm.transaction.isProceso) ? _c('loading-transaction', {
    attrs: {
      "label": _vm.transaction.message
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7c8f10e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Not_Logged_App.vue
// module id = 526
// module chunks = 1